/* eslint-disable jsx-a11y/control-has-associated-label */
import { Skeleton, SkeletonBlock, SkeletonContent, SkeletonLine, } from '@one-thd/sui-atomic-components';
import React from 'react';
export var TableSkeleton = function (_a) {
    var colSpan = _a.colSpan, _b = _a.rows, rows = _b === void 0 ? 4 : _b;
    return (React.createElement(React.Fragment, null, Array(rows)
        .fill(true)
        .map(function (__, i) { return (React.createElement("tr", { key: i },
        React.createElement("td", { colSpan: colSpan },
            React.createElement("div", { className: "sui-pt-4", style: {
                    border: '1px solid #CCCCCB',
                    width: '100%',
                    paddingLeft: '48px',
                    boxSizing: 'border-box',
                } },
                React.createElement(Skeleton, { disablePadding: true, orientation: "horizontal", style: { display: 'flex' } },
                    React.createElement(SkeletonContent, { disablePadding: true, initialSize: "full", style: { maxWidth: '50px', height: '50px' } },
                        React.createElement(SkeletonBlock, null)),
                    React.createElement(SkeletonContent, { disablePadding: true, initialSize: "full", style: {
                            width: '900px',
                            height: '50px',
                            marginLeft: '65px',
                        } },
                        React.createElement(SkeletonLine, { variant: "single" }),
                        React.createElement(SkeletonLine, { variant: "single" }))))))); })));
};
